import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore }     from '@store/authStore'
import { ROUTES, homePathForRole } from '@constants/routes'
import { PageLoader }       from '@components/feedback/PageLoader'

/**
 * PublicRoute — prevents authenticated users from accessing auth pages.
 * Redirects to the role-appropriate dashboard if already logged in.
 */
export function PublicRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const isInitializing  = useAuthStore((s) => s.isInitializing)
  const user            = useAuthStore((s) => s.user)

  if (isInitializing) return <PageLoader />

  if (isAuthenticated) {
    return <Navigate to={homePathForRole(user?.role)} replace />
  }

  return <Outlet />
}
